<template>
  <div class="main">
    <b-card>
      <b-card-body>
        <b-row>
          <b-col md="12" class="d-flex justify-content-end">
            <!-- <b-button variant="primary" v-b-modal.addModal>
              Import Timesheet
            </b-button> -->

            <!-- --SD : We cannot have Bulk IMPORT FOR TIMESHEET -->
            <b-button v-if="IsAdmin()" variant="primary" v-b-modal.addModal>
              <feather-icon icon="PlusIcon" class="mr-50" />
              Import Timesheet
            </b-button>
            
            <b-button variant="primary" class="ml-2" v-b-modal.modal-add-timesheet>
              <feather-icon icon="PlusIcon" class="mr-50" />
              Add Timesheet
            </b-button>
            <!--#region add timesheet-->
            <b-modal
              id="modal-add-timesheet"
              ok-only
              ok-title="Add"
              centered
              size="lg"
              title="Add Timesheet"
              :hide-footer="true"
              ref="addTimesheet"
              @hide="resetForm"
            >
              <validation-observer
                ref="formAddTimesheet"
                #default="{ invalid }"
              >
                <b-form @submit.prevent="addTimesheet">
                  <b-row>
                    <b-col md="12">
                      <b-form-group label="Date" label-for="date">
                        <validation-provider
                          rules="required"
                          #default="{ errors }"
                          name="Date"
                          vid="date"
                        >
                          <b-form-datepicker
                            id="date"
                            placeholder="Date"
                            :state="errors.length > 0 ? false : null"
                            v-model="formData.date"
                            :max="today"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>
                    <b-col sm="12" v-if="IsAdmin()">
                      <b-form-group label="Employee" label-for="employee">
                        <validation-provider
                          rules="required"
                          #default="{ errors }"
                          name="Employee"
                          vid="employee"
                        >
                          <b-form-select
                            :options="employeeOptions"
                            :state="errors.length > 0 ? false : null"
                            v-model="formData.employeeID"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>

                    <b-col md="12">
                      <b-form-group label="Approver" label-for="mc-approver">
                        <validation-provider
                          rules="required"
                          #default="{ errors }"
                          name="Approver"
                          vid="Approver"
                        >
                          <b-form-select
                            id="mc-approver"
                            v-model="formData.approverID"
                            :options="userList"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>
                    <b-col md="12">
                      <b-form-group label="Start Time" label-for="startTime">
                        <validation-provider
                          rules="required"
                          #default="{ errors }"
                          name="Start Time"
                          vid="start Time"
                        >
                          <b-form-timepicker
                            id="startTime"
                            :min="new Date()"
                            v-model="formData.startTime"
                            @change="calculateHoursWorked"
                            locale="en"
                          ></b-form-timepicker>
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>

                    <b-col md="12">
                      <b-form-group label="End Time" label-for="endTime">
                        <validation-provider
                          rules="required"
                          #default="{ errors }"
                          name="End Time"
                          vid="end Time"
                        >
                          <b-form-timepicker
                            id="endTime"
                            :min="new Date()"
                            v-model="formData.endTime"
                            @change="calculateHoursWorked"
                            locale="en"
                          ></b-form-timepicker>
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>

                    <b-col md="12">
                      <b-form-group label="Total Hours" label-for="totalHours">
                        <validation-provider
                          rules="required"
                          #default="{ errors }"
                          name="Total Hours"
                          vid="total hours"
                        >
                          <b-form-input
                            name="totalHours"
                            placeholder="Total Hours"
                            disabled
                            :state="errors.length > 0 ? false : null"
                            v-model="formData.hoursWorked"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>

                    <b-col md="12">
                      <b-form-group label="Description" label-for="description">
                        <validation-provider
                          rules="required"
                          #default="{ errors }"
                          name="Description"
                          vid="description"
                        >
                          <b-form-textarea
                            name="description"
                            placeholder="Description"
                            :state="errors.length > 0 ? false : null"
                            v-model="formData.taskDescription"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>

                    <!-- submit and reset -->
                    <b-col md="12" class="d-flex justify-content-end">
                      <b-button
                        type="submit"
                        @click="addTimesheet()"
                        :disabled="submitting"
                        variant="primary"
                        class="mr-2"
                        ><b-spinner small v-if="submitting"></b-spinner>
                        {{ submitting ? "Submitting..." : "Submit" }}</b-button
                      >
                      <b-button @click="closeModal()" variant="primary">Cancel</b-button>
                    </b-col>
                  </b-row>
                </b-form>
              </validation-observer>
            </b-modal>
            <!--#endregion-->
            <b-button
              variant="outline-success"
              class="ml-2"
              @click="exportToCSV"
            >
              <feather-icon icon="DownloadIcon" class="mr-50" />
              Export to Excel
            </b-button>
          </b-col>
        </b-row>

        <b-modal id="addModal" title="Import Timesheet" v-model="showAddModal" cancel-title="Close" hide-footer centered>
          <b-form @submit.prevent="ImportTimesheet">
            <b-row>
              <div class="m-4">
      
                <b-form-group label="Upload File" label-for="file-input ">
               
               <b-form-file
                 id="file-input"
                 v-model="file"
                 placeholder="Choose a file or drop it here..."
                 drop-placeholder="Drop file here..."
               />
             </b-form-group>
      
             <!-- Display Selected File -->
             <b-card-text class="my-1">
               Selected file: <strong>{{ file ? file.name : 'No file selected' }}</strong>
             </b-card-text>
              </div>
              <!-- File Input -->
              
            </b-row>
      
            <div class="d-flex justify-content-end">
                  <b-button variant="secondary" @click="closeImportmodal()" class="mr-2">Cancel</b-button>
                  <b-button type="button" @click="ImportTimesheet()" variant="primary">Submit</b-button>
                </div>
      
          </b-form>
        </b-modal>

        <b-row class="justify-content-between">
          <b-col cols=" 12" md="2" sm="2" class="my-1">
            <b-form-group class="mb-0">
              <label class="d-inline-block text-sm-left mr-50">Per page</label>
              <b-form-select
                id="perPageSelect"
                v-model="perPage"
                size="sm"
                :options="pageOptions"
                class="w-50"
              />
            </b-form-group>
          </b-col>
          <b-col cols=" 12" md="2" sm="2" class="text-right my-2">
            <!-- <b-form-group label="Filter" label-cols-sm="3" label-align-sm="right" label-size="sm"
              label-for="filterInput" class="mb-0">
              <b-input-group size="sm">
                <b-form-input id="filterInput" v-model="filters.reference" type="search" placeholder="Type to Search" />
                <b-input-group-append>
                  <b-button :disabled="!filters" @click="clearFilters()">
                    Clear
                  </b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group> -->
            <b-button
              size="sm"
              variant="outline-secondary"
              @click="clearFilters"
              class="ml-2"
            >
              Clear Filters
            </b-button>
          </b-col>

          <b-col cols="12">
            <div class="d-flex justify-content-center" v-if="mainLoading">
              <b-spinner
                variant="success"
                label="Spinning"
                style="width: 3rem; height: 3rem"
              ></b-spinner>
            </div>
            <b-table
              v-if="!mainLoading"
              striped
              hover
              responsive
              :per-page="perPage"
              :current-page="currentPage"
              :items="filteredTimesheets()"
              :fields="timesheet_fields"
              :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc"
              :sort-direction="sortDirection"
              @filtered="onFiltered"
            >
              <!-- Employee Filter -->
              <template #head(employeeName)="scope">
                <div class="d-flex flex-column">
                  <span>Employee</span>
                  <b-form-input
                    v-model="filters.employeeName"
                    placeholder="Filter by Name"
                    size="sm"
                    class="mt-1"
                  />
                </div>
              </template>

              <!-- Module Filter -->
              <template #head(moduleType)="scope">
                <div class="d-flex flex-column">
                  <span>Module</span>
                  <b-form-select
                    v-model="filters.module"
                    :options="[
                      { value: null, text: 'All' },
                      ...timesheetModules,
                    ]"
                    size="sm"
                    class="mt-1"
                  />
                </div>
              </template>

              <!-- Total Hours Filter -->
              <template #head(hoursWorked)="scope">
                <div class="d-flex flex-column">
                  <span>Total Hours</span>
                  <b-form-input
                    v-model="filters.hoursWorked"
                    placeholder="Filter by Hours"
                    size="sm"
                    class="mt-1"
                  />
                </div>
              </template>

              <!-- Status Filter -->
              <template #head(status)="scope">
                <div class="d-flex flex-column">
                  <span>Status</span>
                  <b-form-select
                    v-model="filters.status"
                    size="sm"
                    class="mt-1"
                  >
                    <option :value="null">All</option>
                    <option
                      v-for="status in timesheetStatus"
                      :key="status.value"
                      :value="status.value"
                    >
                      {{ status.text }}
                    </option>
                  </b-form-select>
                </div>
              </template>

              <!-- Comment Filter -->
              <template #head(taskDescription)="scope">
                <div class="d-flex flex-column">
                  <span>Comment</span>
                  <b-form-input
                    v-model="filters.taskDescription"
                    placeholder="Filter by Comment"
                    size="sm"
                    class="mt-1"
                  />
                </div>
              </template>

              <!-- Submitted On Filter -->
              <template #head(date)="scope">
                <div class="d-flex flex-column">
                  <span>Submitted On</span>
                  <b-form-datepicker
                    v-model="filters.date"
                    placeholder="Select Date"
                    size="sm"
                    class="mt-1"
                    @input="currentPage = 1"
                    :date-format-options="{
                      year: 'numeric',
                      month: '2-digit',
                      day: '2-digit',
                    }"
                  />
                </div>
              </template>

              <template #cell(date)="data">
                {{ formatDateDDMMMYYYY(data.item.date) }}
              </template>

              <!-- <template #cell(startDate)="data">
                {{ formatDate(data.item.date) }}
              </template>
              <template #cell(toDate)="data">
                {{ formatDate(data.item.date) }}
              </template> -->

              <template v-slot:cell(actions)="data">
                <b-dropdown
                  variant="link"
                  toggle-class="p-0"
                  no-caret
                  class="m-1"
                >
                  <template #button-content>
                    <feather-icon
                      icon="MoreVerticalIcon"
                      size="16"
                      class="align-middle text-body"
                    />
                  </template>

                  <b-dropdown-item
                    v-if="checkPermissions(data.item)"
                    @click="timesheetAction('APPROVED', data.item)"
                  >
                    <feather-icon icon="CheckIcon" />
                    <span class="align-middle ml-50">Approve</span>
                  </b-dropdown-item>

                  <b-dropdown-item
                    v-if="checkPermissions(data.item)"
                    @click="timesheetAction('REJECTED', data.item)"
                  >
                    <feather-icon icon="XIcon" />
                    <span class="align-middle ml-50">Reject</span>
                  </b-dropdown-item>

                  <b-dropdown-item @click="viewTimesheet(data.item)">
                    <feather-icon icon="EyeIcon" />
                    <span class="align-middle ml-50">View</span>
                  </b-dropdown-item>

                  <!-- <b-dropdown-item v-if="data.item.status === 'PENDING' && data.item.moduleType === moduleReference" @click="editTimesheet(data.item)">
                    <feather-icon icon="EditIcon" />
                    <span class="align-middle ml-50">Edit</span>
                  </b-dropdown-item> -->
                  <!-- <b-dropdown-item v-if="data.item.moduleType === moduleReference" @click="deleteTimesheet(data.item.id)">
                    <feather-icon icon="TrashIcon" />
                    <span class="align-middle ml-50">Delete</span>
                  </b-dropdown-item> -->
                </b-dropdown>
              </template>
            </b-table>
            <!-- #region view timesheet -->
            <b-modal
              id="modal-view-timesheet"
              ok-only
              ok-title="View"
              centered
              size="lg"
              title="View timesheet"
              :hide-footer="true"
              ref="viewTimesheet"
            >
              <b-form>
                <b-row>
                  <b-col sm="12">
                    <b-form-group label="Date" label-for="date">
                      <b-form-datepicker
                        id="date"
                        placeholder="Date"
                        v-model="timesheetId.date"
                        disabled
                      />
                    </b-form-group>
                  </b-col>

                  <b-col sm="12">
                    <b-form-group label="Employee" label-for="employee">
                      <b-form-select
                        :options="employeeListOptions"
                        v-model="timesheetId.employeeID"
                        :disabled="true"
                      />
                    </b-form-group>
                  </b-col>

                  <b-col md="12">
                    <b-form-group label="Total Hours" label-for="totalHours">
                      <b-form-input
                        name="totalHours"
                        placeholder="Total Hours"
                        readonly
                        v-model="timesheetId.hoursWorked"
                      />
                    </b-form-group>
                  </b-col>

                  <!-- <b-col sm="12">
                    <b-form-group label="Start Date" label-for="startDate">
                      <b-form-timepicker id="startDate" placeholder="Start Date" v-model="timesheetId.startDate"
                        disabled />
                    </b-form-group>
                  </b-col>
                  <b-col sm="12">
                    <b-form-group label="End Date" label-for="endDate">
                      <b-form-timepicker id="endDate" placeholder="End Date" v-model="timesheetId.endDate" disabled />
                    </b-form-group>
                  </b-col> -->

                  <b-col md="12">
                    <b-form-group label="Description" label-for="description">
                      <b-form-textarea
                        name="description"
                        placeholder="Description"
                        readonly
                        v-model="timesheetId.taskDescription"
                      />
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-form>
            </b-modal>
            <!-- #endregion -->
            <!-- #region edit timesheet -->
            <!-- Edit Timesheet Modal -->
            <b-modal
              id="modal-edit-timesheet"
              ok-only
              ok-title="Edit"
              centered
              size="lg"
              title="Edit timesheet"
              :hide-footer="true"
              ref="editTimesheet"
            >
              <validation-observer
                ref="formEditTimesheet"
                #default="{ invalid }"
              >
                <b-form @submit.prevent="saveEditedTimesheet">
                  <b-row>
                    <b-col md="12">
                      <b-form-group label="Date" label-for="date">
                        <validation-provider
                          rules="required"
                          #default="{ errors }"
                          name="date"
                          vid="date"
                        >
                          <b-form-datepicker
                            id="date"
                            placeholder="Date"
                            :state="errors.length > 0 ? false : null"
                            v-model="editFormData.date"
                            :max="today"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>

                    <b-col sm="12" v-if="IsAdmin()">
                      <b-form-group label="Employee" label-for="employee">
                        <validation-provider
                          rules="required"
                          #default="{ errors }"
                          name="employee"
                          vid="employee"
                        >
                          <b-form-select
                            :options="employeeOptions"
                            :state="errors.length > 0 ? false : null"
                            v-model="editFormData.employeeID"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>

                    <!-- <b-col md="12">
                      <b-form-group label="Start Time" label-for="startTime">
                        <validation-provider rules="required" #default="{ errors }" name="Start Time"
                          vid="start Time">
                          <b-form-timepicker id="startTime" :min="new Date()" v-model="editFormData.startTime"
                           @change="calculateHoursWorked"
                           locale="en"></b-form-timepicker>
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>

                    <b-col md="12">
                      <b-form-group label="End Time" label-for="endTime">
                        <validation-provider rules="required" #default="{ errors }" name="End Time"
                          vid="end Time">
                          <b-form-timepicker id="endTime" :min="new Date()" v-model="editFormData.endTime"
                           @change="calculateHoursWorked"
                           locale="en"></b-form-timepicker>
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>

                    <b-col md="12">
                      <b-form-group label="Total Hours" label-for="totalHours">
                        <validation-provider rules="required" #default="{ errors }" name="Total Hours"
                          vid="total hours">
                          <b-form-input name="totalHours" placeholder="Total Hours"
                          disabled :state="errors.length > 0 ? false : null" v-model="editFormData.hoursWorked" />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col> -->

                    <b-col md="12">
                      <b-form-group label="Total Hours" label-for="totalHours">
                        <validation-provider
                          rules="required"
                          #default="{ errors }"
                          name="total hours"
                          vid="total hours"
                        >
                          <b-form-input
                            name="totalHours"
                            placeholder="Total Hours"
                            disabled
                            :state="errors.length > 0 ? false : null"
                            v-model="editFormData.hoursWorked"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>
                    <b-col md="12">
                      <b-form-group label="Start Date" label-for="startDate">
                        <validation-provider
                          rules="required"
                          #default="{ errors }"
                          name="startDate"
                          vid="startDate"
                        >
                          <b-form-datepicker
                            id="startDate"
                            placeholder="Start Date"
                            :state="errors.length > 0 ? false : null"
                            v-model="editFormData.startDate"
                            :max="today"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>
                    <b-col md="12">
                      <b-form-group label="End Date" label-for="endDate">
                        <validation-provider
                          rules="required"
                          #default="{ errors }"
                          name="endDate"
                          vid="endDate"
                        >
                          <b-form-datepicker
                            id="endDate"
                            placeholder="End Date"
                            :state="errors.length > 0 ? false : null"
                            v-model="editFormData.endDate"
                            :max="today"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>
                    <b-col md="12">
                      <b-form-group label="Description" label-for="description">
                        <validation-provider
                          rules="required"
                          #default="{ errors }"
                          name="description"
                          vid="description"
                        >
                          <b-form-textarea
                            name="description"
                            placeholder="Description"
                            :state="errors.length > 0 ? false : null"
                            v-model="editFormData.taskDescription"
                          />
                          <small class="text-danger">{{ errors[0] }}</small>
                        </validation-provider>
                      </b-form-group>
                    </b-col>

                    <!-- submit and reset -->
                    <b-col md="12" class="d-flex justify-content-end">
                      <b-button
                        type="submit"
                        variant="primary"
                        class="mr-2"
                        @click="saveEditedTimesheet"
                      >
                        Save
                      </b-button>
                      <b-button
                        variant="primary"
                        @click="$bvModal.hide('modal-edit-timesheet')"
                        >Cancel</b-button
                      >
                    </b-col>
                  </b-row>
                </b-form>
              </validation-observer>
            </b-modal>

            <!-- #endregion -->
          </b-col>

          <b-col cols="12">
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              align="center"
              size="sm"
              class="mt-2"
            />
            <b-form-group>
              Showing
              {{ totalRows > 0 ? perPage * (currentPage - 1) + 1 : 0 }}
              to
              {{
                totalRows > 0 ? Math.min(perPage * currentPage, totalRows) : 0
              }}
              of
              {{ totalRows > 0 ? totalRows : 0 }}
              entries
            </b-form-group>
          </b-col>
        </b-row>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import {
  BTable,
  BAvatar,
  BBadge,
  BRow,
  BCol,
  BFormGroup,
  BSpinner,
  BFormSelect,
  BPagination,
  BInputGroup,
  BFormInput,
  BInputGroupAppend,
  BButton,
  BFormFile,
  BCard,
  BDropdown,
  BLink,
  BDropdownItem,
  BTab,
  BTabs,
  BFormDatepicker,
  BFormTextarea,
  BFormTimepicker,
  BForm,
  BCardBody,
} from "bootstrap-vue";

import { mapActions, mapGetters } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required, email } from "@validations";
import { customError, fnSortingDropdown } from "@/libs/customFn";
import { TimesheetStatus, TimesheetModules } from "@/libs/defaultList";
import { IsAdmin } from "@/@core/utils/validations/permissionCheck";
import timesheet from "@/store/timesheet";
export default {
  components: {
    BCard,
    BTable,
    BAvatar,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    BSpinner,
    BDropdown,
    BLink,
    BFormFile,
    BDropdownItem,
    BTab,
    BTabs,
    BFormDatepicker,
    BFormTextarea,
    ValidationProvider,
    ValidationObserver,
    BFormTimepicker,
    BForm,
    BCardBody,
  },
  data() {
    return {
      perPage: 5,
      pageOptions: [3, 5, 10],
      totalRows: 1,
      currentPage: 1,
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: ["employeeID", "taskDescription"],
      filterOn: [],
      timesheets: [],

      timesheet_fields: [
        {
          key: "employeeName",
          label: "Employee",
          sortable: true,
          filter: true,
        },
        { key: "moduleType", label: "Module", sortable: true },
        { key: "hoursWorked", label: "Total Hours", sortable: true },
        { key: "status", label: "Status", sortable: true },
        {
          key: "taskDescription",
          label: "Comment",
          sortable: true,
          filter: true,
        },
        { key: "date", label: "Submitted On", sortable: true },
        { key: "actions", label: "Actions" },
      ],
      moduleReference: "HRMS",
      timesheetStatus: TimesheetStatus,
      // optionstimesheetStatus: [
      // { value: 'PENDING', text: "Pending" },
      // { value: 'REJECTED', text: "Rejected" },
      // { value: 'APPROVED', text: "Approved" },
      // ],
      timesheetModules: TimesheetModules,
      userId: null,
      formData: {
        id: null,
        parentID: null,
        typeID: null,
        employeeID: null,
        date: null,
        hoursWorked: null,
        taskDescription: null,
        approverID: null,
        approvalDate: null,
        status: null,
        note: null,
        startDate: null,
        endDate: null,
        reference: null,
      },
      timesheetId: {
        date: null,
        projectID: null,
        employeeID: null,
        hoursWorked: null,
        taskDescription: null,
        startDate: null,
        endDate: null,
        startTime: null,
        endTime: null,
      },
      mainLoading: false,
      projectOptions: [],
      employeeOptions: [],
      employeeListOptions: [],
      submitting: false,
      // validation rules
      required,
      email,
      userList: [],
      editFormData: {
        id: null,
        parentID: null,
        typeID: null,
        employeeID: null,
        date: null,
        hoursWorked: null,
        taskDescription: null,
        approverID: null,
        approvalDate: null,
        status: null,
        note: null,
        startDate: null,
        endDate: null,
        reference: null,
      },
      filters: {
        reference: "",
        status: null,
        module: null,
        employeeName: "",
        hoursWorked: "",
        taskDescription: "",
        date: "",
      },
      today: new Date().toISOString().split("T")[0],
    };
  },
  // mounted() {
  //   // Set the initial number of items
  //   this.totalRows = this.filteredTimesheets.length;
  // },
  computed: {
    ...mapGetters("employeeModule", {
      employeeList: "employees",
      loading: "loading",
    }),
    ...mapGetters("allocationModule", {
      loading: "loading",
    }),
    ...mapGetters("serviceModule", {
      timesheetList: "timesheetList",
      timesheet: "timesheet",
      loading: "loading",
    }),
    ...mapGetters("userModule", {
      users: "users",
      loading: "loading",
    }),

    formattedTimesheets() {
      return this.timesheets.map((timesheet) => {
        return {
          ...timesheet,
          employeeName: this.getEmployee(timesheet.employeeID), // Map employeeID to full name
        };
      });
    },
  },
  methods: {
    ...mapActions("serviceModule", [
      "getServiceTimesheetListAction",
      "getServiceTimesheetAction",
      "postServiceTimesheetAction",
      "putServiceTimesheetAction", "importTimesheetAction"
    ]),
    ...mapActions("employeeModule", ["getEmployeeListAction"]),
    ...mapActions("userModule", ["getUserListByRoleAction"]),

    // filterTable() {
    //   this.timesheets
    // },

    //   formatHoursWorked() {
    //   let value = parseFloat(this.formData.hoursWorked);
    //   if (isNaN(value)) return;
    //   this.formData.hoursWorked = value.toFixed(2);
    // },

    closeImportmodal() {
      this.$bvModal.hide("addModal");
      this.showAddModal = false;
      if (IsAdmin()) {
           this.getServiceTimesheetListAction().then(() => {
            this.timesheets = this.timesheetList;
            this.totalRows = this.timesheets.length;
          });
        } else {
        
           this.getServiceTimesheetListAction().then(() => {
            this.timesheets = this.timesheetList.filter(
              (x) => x.employeeID == id || x.approverID == id  || x.employeeID == userid
            );
            console.log("this.timesheets", this.timesheets);
            this.totalRows = this.timesheets.length;
          });
        }
    },

    ImportTimesheet()
    {
      let docForm = new FormData();

      docForm.append("File", this.file);

      this.importTimesheetAction(docForm)
          .then(() => {
            this.successAdd();
            this.$bvModal.hide("addModal");
            this.showAddModal = false;
            this.file = null;
          })
          .catch((error) => {
              console.log(error);
              // Extract the error message from the response
              const errorMessage = error.response && error.response.data && error.response.data.message 
              ? error.response.data.message 
              : 'An unexpected error occurred.';
        
                this.$swal({
                  icon: 'error',
                  title: 'Error!',
                  text: errorMessage, // Display the extracted error message
                  customClass: {
                      confirmButton: 'btn btn-success',
                 },
                });
              this.showAddModal = false;
            //this.errorAdd();
          });
    },

  getEmployeeUser(id){
    //console.log("iddddddddddddddddddddddddddddddddddd", id);
    const employee = this.employeeList.find((s) => s.refId === id);
    //console.log("employeeeeeeeeeeeeeeeeeeeeeee", employee);
    return  employee == null ? '' : employee.id;
  },

    formatDate2(date) {
      if (!date) return "-";
      return new Date(date).toISOString().split("T")[0]; // Returns YYYY-MM-DD
    },

    formatDate(date) {
      const options = { year: "numeric", month: "short", day: "numeric" };
      return new Date(date).toLocaleDateString("en-US", options);
    },
    formatMonth(date) {
      const options = { month: "long" };
      return new Date(date).toLocaleDateString("en-US", options);
    },
    getEmployee(id) {
      const employee = this.employeeList.find((s) => s.id === id ||  s.refId === id);
      return employee ? employee.firstName + " " + employee.lastName : "-";
    },
    getStatusVariant(status) {
      switch (status) {
        case "PENDING":
          return "light-info";
        case "APPROVE":
          return "light-warning";
        case "REJECT":
          return "light-danger";
        case "DONE":
          return "light-success";
        default:
          return "secondary";
      }
    },

    checkPermissions(item) {
      console.log("Item Status:", item.status);
      console.log(
        "Module Type:",
        item.moduleType,
        "Expected:",
        this.moduleReference
      );
      console.log("User is Admin:", IsAdmin());
      console.log("User ID:", this.userId, "Approver ID:", item.approverID);

      return (
        item.status === "PENDING" &&
        (IsAdmin() || this.userId === item.approverID)
      );
    },

    calculateHoursWorked() {
      if (this.formData.startTime && this.formData.endTime) {
        const start = this.convertToDate(this.formData.startTime);
        const end = this.convertToDate(this.formData.endTime);

        if (start > end) {
          this.errorStart();
        }

        this.formData.startDate = start;
        this.formData.endDate = end;

        const diff = end - start;
        const hours = diff / (1000 * 60 * 60);

        this.formData.hoursWorked = hours >= 0 ? hours.toFixed(2) : 0;
      }
    },

    convertToDate(time) {
      const [hours, minutes] = time.split(":");
      const date = new Date();
      date.setHours(hours, minutes, 0, 0);
      return date;
    },

    successAdd() {
      this.$swal({
        title: "Timesheet Added!",
        text: "You have successfully added a timesheet!",
        icon: "success",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },

    errorAdd(error) {
      this.$swal({
        title: "Error!",
        text: error ? error : " Failed!",
        icon: "error",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },
    successEdit() {
      this.$swal({
        title: "Timesheet Updated!",
        text: "You have successfully updated the timesheet!",
        icon: "success",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },

    errorEdit(error) {
      this.$swal({
        title: "Error!",
        text: error ? error : " Failed!",
        icon: "error",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },
    success(message) {
      this.$swal({
        title: "Timesheet Status Updated!",
        text: message,
        icon: "success",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },
    async addTimesheet() {
      this.submitting = true;
      const isValid = await this.$refs.formAddTimesheet.validate();
      if (isValid) {
        try {
          if (
            this.formData.startTime === null ||
            this.formData.startTime === ""
          ) {
            this.errorTime();
          }
          if (this.formData.endTime === null || this.formData.endTime === "") {
            this.errorTime();
          }

          if (this.formData.employeeID == null){
            const userData = JSON.parse(localStorage.getItem("userData"));
          this.userId = userData.id;
          const emp = this.getEmployeeUser(this.userId);
       
          this.formData.employeeID = emp;
          }
          
          const payload = {
            parentID: this.formData.parentID,
            employeeID: this.formData.employeeID,
            date: this.formData.date,
            hoursWorked: this.formData.hoursWorked,
            startDate: this.formData.startDate,
            endDate: this.formData.endDate,
            taskDescription: this.formData.taskDescription,
            moduleReference: this.moduleReference,
            approverID: this.formData.approverID,
          };
          
          await this.postServiceTimesheetAction(payload).then(() =>
        {
          this.successAdd();
          this.fetchTimesheetData(this.userId);

    
        });
    
          this.$bvModal.hide("modal-add-timesheet");
          this.resetForm();
          window.location.reload();
        } catch (error) {
          this.errorAdd(error.response.data.message);
          this.$bvModal.hide("modal-add-timesheet");
          window.location.reload();
        }
      } else {
        this.submitting = false;
      }
    },
    async deleteTimesheet(id) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes, delete it!",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.removeTimesheetAction(id)
            .then(() => {
              this.$swal({
                icon: "success",
                title: "Deleted!",
                text: "Timesheet has been deleted",
                customClass: {
                  confirmButton: "btn btn-success",
                },
              });
              this.getServiceTimesheetListAction();
            })
            .catch((error) => {
              this.$swal({
                icon: "error",
                title: "Error!",
                text: error,
                customClass: {
                  confirmButton: "btn btn-danger",
                },
              });
            });
        } else if (result.dismiss === "cancel") {
          this.$swal({
            title: "Cancelled",
            text: "Timesheet is safe :)",
            icon: "error",
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        }
      });
    },
    viewTimesheet(item) {
      this.timesheetId = { ...item };
      this.$refs.viewTimesheet.show();
    },

    closeModal(){
      this.$bvModal.hide("modal-add-timesheet");
      //this.$ref.addTimesheet.hide();
    },

    editTimesheet(item) {
      this.editFormData = { ...item };
      this.$refs.editTimesheet.show();
    },

    errorStart(data) {
      let msg = null;
      // if (data) msg = this.getErrorString(data);
      this.$swal({
        title: "Error!",
        html: "Start time cannot be past end time.",
        icon: "error",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },

    errorTime(data) {
      let msg = null;
      // if (data) msg = this.getErrorString(data);
      this.$swal({
        title: "Error!",
        html: "Please select a start time and end time.",
        icon: "error",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    },

    async saveEditedTimesheet() {
      const isValid = await this.$refs.formEditTimesheet.validate();
      if (isValid) {
        try {
          const payload = {
            id: this.editFormData.id,
            parentID: this.editFormData.parentID,
            employeeID: this.editFormData.employeeID,
            date: this.editFormData.date,
            hoursWorked: this.editFormData.hoursWorked,
            startDate: this.editFormData.startDate,
            endDate: this.editFormData.endDate,
            approverID: localStorage.getItem("approverID"),
            taskDescription: this.editFormData.taskDescription,
            status: "PENDING",
          };
          await this.putServiceTimesheetAction(payload);
          this.successEdit();
          // Reload timesheet data
          await this.fetchTimesheetData();
          this.$bvModal.hide("modal-edit-timesheet");
        } catch (error) {
          console.error(
            "Error in saveEditedTimesheet:",
            error.response || error.message || error
          );
          this.errorEdit(
            error.response ? error.response.data.message : error.message
          );
        }
      }
    },

    resetForm() {
      this.formData = {
        parentID: null,
        employeeID: null,
        date: null,
        hoursWorked: null,
        startDate: null,
        endDate: null,
        taskDescription: null,
      };
      this.submitting = false;
    },

    async timesheetAction(status, timesheet) {
      try {
        await this.getServiceTimesheetAction({
          modulereference: timesheet.moduleType,
          id: timesheet.id,
        });

        // confirm update
        const result = await this.$swal({
          title: "Are you sure?",
          text: "You will not be able to revert your changes!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Yes, update status!",
          cancelButtonText: "Cancel",
          customClass: {
            confirmButton: "btn btn-primary",
            cancelButton: "btn btn-outline-danger ml-1",
          },
          buttonsStyling: false,
        });

        if(timesheet.approverID == null){
          const userData = JSON.parse(localStorage.getItem("userData"));
    console.log("🚀 ~ mounted ~ userData:", IsAdmin);
    this.userId = userData.id;

    const emp = this.getEmployeeUser(this.userId);
    console.log("userData", userData);
    console.log("emppp", emp);
          timesheet.approverID = emp;
        }

        if (result.isConfirmed) {
          const payload = {
            id: timesheet.id,
            approverID: timesheet.approverID,
            status: status,
            note: status,
            moduleReference: timesheet.moduleType,
          };

          try {
            await this.putServiceTimesheetAction(payload).then(() => {
              this.success();
              //this.fetchTimesheetData();
              this.getServiceTimesheetListAction().then(() => {
                this.timesheets = this.timesheetList;
                this.totalRows = this.timesheets.length;
              });
            });
          } catch (updateError) {
            console.error("Error updating timesheet:", updateError);
            await this.$swal({
              title: "Error",
              text: "An error occurred while updating the timesheet.",
              icon: "error",
              customClass: {
                confirmButton: "btn btn-danger",
              },
            });
          }
        }
      } catch (error) {
        console.error("Error fetching timesheet:", error);
        await this.$swal({
          title: "Error",
          text: "An error occurred while fetching the timesheet data.",
          icon: "error",
          customClass: {
            confirmButton: "btn btn-danger",
          },
        });
      }
    },
    async fetchTimesheetData(id, userid) {
      this.mainLoading = true;
      try {
        let loader = this.$swal({
          title: "Loading...",
          text: "Please wait while the details are loading...",
          allowEscapeKey: false,
          allowOutsideClick: false,
          didOpen: () => {
            this.$swal.showLoading();
          },
        });

        if (IsAdmin()) {
          await this.getServiceTimesheetListAction().then(() => {
            this.timesheets = this.timesheetList;
            this.totalRows = this.timesheets.length;
          });
        } else {
        
          await this.getServiceTimesheetListAction().then(() => {
            this.timesheets = this.timesheetList.filter(
              (x) => x.employeeID == id || x.approverID == id  || x.employeeID == userid
            );
            console.log("this.timesheets", this.timesheets);
            this.totalRows = this.timesheets.length;
          });
        }

        // await this.getEmployeeListAction().then(() => {

        //   if(!IsAdmin()) {
        //     console.log("matoss")
        //     let employee = this.employeeList.filter(x => x.refId == this.userId)[0];
        //     if(employee){
        //       this.formData.employeeID = employee.id;
        //       this.editFormData.employeeID = employee.id;
        //       //this.timesheetId.employeeID = employee.id;
        //     } else {
        //       customError('You do not have any employee profile!')
        //     }
        //   }

        //   this.employeeOptions = this.employeeList.filter(x => (IsAdmin() || (x.refId != this.userId))).map((employee) => ({
        //     value: employee.id,
        //     text: `${employee.firstName} ${employee.lastName}`,
        //   }));

        //   this.employeeListOptions = this.employeeList.map((employee) => ({
        //     value: employee.id,
        //     text: `${employee.firstName} ${employee.lastName}`,
        //   }));

        // });

        await this.getUserListByRoleAction("staff");
        let allUser = this.users.filter((z) => z.id !== this.userId);
        allUser = allUser.map((user) => {
          return { text: `${user.firstName} ${user.lastName}`, value: user.id };
        });
        this.userList = fnSortingDropdown(allUser);

        loader.close();
      } catch (error) {
        console.log(error);
      } finally {
        this.mainLoading = false;
      }
    },
    clearFilters() {
      this.filters = {
        reference: "",
        status: null,
        module: null,
        employeeName: "",
        hoursWorked: "",
        taskDescription: "",
        date: "",
      };
      this.currentPage = 1;
      this.timesheets = this.timesheetList;
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.currentPage = 1;
      this.totalRows = filteredItems.length;
    },
    filteredTimesheets() {
      return this.formattedTimesheets.filter((ts) => {
        return (
          // Employee Name Filter
          (!this.filters.employeeName ||
            ts.employeeName
              .toLowerCase()
              .includes(this.filters.employeeName.toLowerCase())) &&
          // Module Filter
          (!this.filters.module || ts.moduleType === this.filters.module) &&
          // Total Hours Filter
          (!this.filters.hoursWorked ||
            ts.hoursWorked.toString().includes(this.filters.hoursWorked)) &&
          // Status Filter
          // (!this.filters.status || ts.status === this.filters.status) &&
          (!this.filters.status ||
            this.filters.status === null ||
            ts.status === this.filters.status) && // Allow 'All'
          // Task Description (Comment) Filter
          (!this.filters.taskDescription ||
            (ts.taskDescription &&
              ts.taskDescription
                .toLowerCase()
                .includes(this.filters.taskDescription.toLowerCase()))) &&
          // Submitted On (Date) Filter
          (!this.filters.date ||
            this.formatDateDDMMMYYYY(ts.date) === this.formatDateDDMMMYYYY(this.filters.date))
        );
      });
    },
    exportToCSV() {
      if (!this.timesheets || this.timesheets.length === 0) {
        alert("No data to export!");
        return;
      }

      // Define column headers
      let csvContent = "data:text/csv;charset=utf-8,";
      csvContent += "Employee,Module,Total Hours,Status,Comment,Date\n";

      // Append data rows
      this.timesheets.forEach((ts) => {
        let row = [
          this.getEmployee(ts.employeeID),
          ts.moduleType,
          ts.hoursWorked,
          ts.status,
          ts.taskDescription,
          this.formatDateDDMMMYYYY(ts.date),
        ].join(",");

        csvContent += row + "\n";
      });

      // Create a downloadable link
      const encodedUri = encodeURI(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute(
        "download",
        `Timesheets_${new Date().toISOString().slice(0, 10)}.csv`
      );
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    formatDateDDMMMYYYY(dateStr) {
  const date = new Date(dateStr);
  const day = String(date.getDate()).padStart(2, "0");
  const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", 
                      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  const month = monthNames[date.getMonth()];
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
}
  },
  async mounted() {
    await this.getEmployeeListAction().then(() => {
      if (!IsAdmin()) {

        let employee = this.employeeList.filter(
          (x) => x.refId == this.userId
        )[0];
        if (employee) {
          this.formData.employeeID = employee.id;
          this.editFormData.employeeID = employee.id;
          //this.timesheetId.employeeID = employee.id;
        } else {
          customError("You do not have any employee profile!");
        }
      }

      this.employeeOptions = this.employeeList
        .filter((x) => IsAdmin() || x.refId != this.userId)
        .map((employee) => ({
          value: employee.id,
          text: `${employee.firstName} ${employee.lastName}`,
        }));

      this.employeeListOptions = this.employeeList.map((employee) => ({
        value: employee.id,
        text: `${employee.firstName} ${employee.lastName}`,
      }));
    });

    const userData = JSON.parse(localStorage.getItem("userData"));
    console.log("🚀 ~ mounted ~ userData:", IsAdmin);
    this.userId = userData.id;

    const emp = this.getEmployeeUser(this.userId);
    console.log("userData", userData);
    console.log("emppp", emp);
    await this.fetchTimesheetData(emp, this.userId);
    this.timesheetStatus = fnSortingDropdown(this.timesheetStatus);
  },
  watch: {
    "formData.startTime": "calculateHoursWorked",
    "formData.endTime": "calculateHoursWorked",
  },

  setup(props) {
    return { IsAdmin };
  },
};
</script>

<style>
select:disabled,
.form-control:disabled {
  background-color: white !important;
  color: #2c2c2c !important;
  opacity: 1 !important;
  cursor: not-allowed;
}

.table-responsive{
  min-height: 380px;
}
</style>
